/* Catchy Device Finder – device page: scans the products and shows the ones that fit the chosen device.
   Needs catchy-device-core.js (loaded before this file). */
(function () {
  'use strict';
  var C = window.CatchyDeviceCore;
  if (!C || window.CatchyDevicePage) return;
  var ROOT = C.ROOT, esc = C.esc, slug = C.slug, data = C.data, findBrand = C.findBrand, findModel = C.findModel, displayName = C.displayName,
    productFits = C.productFits, isUsbC = C.isUsbC, saveLast = C.saveLast, initFinder = C.initFinder;

  /* ------------------------------------------------------------ collection data */
  var mem = {};
  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  /* Loads every page of a collection. onProgress(items) is called as pages arrive (newest first). */
  function loadCollection(handle, sort, onProgress) {
    var ck = 'cd:col:v4:' + handle + ':' + sort;
    if (!mem[ck]) {
      try {
        var c = JSON.parse(sessionStorage.getItem(ck) || 'null');
        if (c && Date.now() - c.t < 30 * 60 * 1000) mem[ck] = { done: Promise.resolve(c.items), items: c.items, listeners: [] };
      } catch (e) {}
    }
    if (!mem[ck]) {
      var st = mem[ck] = { items: [], listeners: [] };
      var base = ROOT + 'collections/' + encodeURIComponent(handle) + '?view=catchy-device&sort_by=' + encodeURIComponent(sort) + '&page=';
      var pagesData = {};
      function flush() {
        var all = [], p = 1;
        while (pagesData[p]) { all = all.concat(pagesData[p]); p++; }
        st.items = all;
        st.listeners.forEach(function (f) { try { f(all); } catch (e) {} });
      }
      st.done = fetchJson(base + 1).then(function (first) {
        pagesData[1] = first.items || []; flush();
        var total = Math.min(first.pages || 1, 40), next = 2;
        function worker() {
          if (next > total) return Promise.resolve();
          var p = next++;
          return fetchJson(base + p).catch(function () { return fetchJson(base + p); })
            .then(function (j) { pagesData[p] = j.items || []; flush(); return worker(); });
        }
        return Promise.all([worker(), worker(), worker(), worker()]).then(function () {
          var all = []; for (var p = 1; p <= total; p++) all = all.concat(pagesData[p] || []);
          st.items = all;
          try { sessionStorage.setItem(ck, JSON.stringify({ t: Date.now(), items: all })); } catch (e) {}
          return all;
        });
      });
      st.done.catch(function () { delete mem[ck]; });
    }
    var s = mem[ck];
    if (onProgress) { s.listeners.push(onProgress); if (s.items.length) onProgress(s.items); }
    return s.done;
  }
  /* row: [id, title, url, price, compare, image, available, created, values, priceCents, compareCents, collections, type] */
  function row(r) {
    return { id: r[0], title: r[1], url: r[2], price: r[3], compare: r[4], img: r[5], avail: !!r[6], created: r[7], vals: r[8] || '',
      cents: r[9] || 0, compareCents: r[10] || 0, colls: ' ' + (r[11] || '') + ' ', type: r[12] || '', colors: colorsOf(r[13]), vid: r[14] || 0 };
  }
  /* "Black~files/x.jpg?v=1&width=400~123|Blue~~124" -> [{n, key, img, vid}] */
  function colorsOf(s) {
    return String(s || '').split('|').filter(Boolean).map(function (x) {
      var p = x.split('~');
      return { n: p[0], key: p[0].trim().toLowerCase(), img: p[1] ? '//' + location.host + '/cdn/shop/' + p[1] : '', vid: +p[2] || 0 };
    });
  }
  function singular(w) { return w.length > 3 ? w.replace(/(ies)$/, 'y').replace(/(sses)$/, 'ss').replace(/([^s])s$/, '$1') : w; }
  function wordsOf(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9؀-ۿ]+/g, ' ').trim().split(' ').filter(Boolean).map(singular); }
  /* is the product in this category? (one of its collections, or its title says so) */
  function hasWords(list, d) {
    var tw = d._tw || (d._tw = ' ' + wordsOf(d.title + ' ' + d.type).join(' ') + ' ');
    return list.some(function (ws) { return ws.every(function (w) { return tw.indexOf(' ' + w + ' ') > -1; }); });
  }
  function inTab(t, d) {
    if (!t.exWords) t.exWords = (t.ex || []).map(wordsOf).filter(function (w) { return w.length; });
    if (t.exWords.length && hasWords(t.exWords, d)) return false;
    if (t.handles[0] === '*') return true;
    for (var i = 0; i < t.handles.length; i++) if (d.colls.indexOf(' ' + t.handles[i] + ' ') > -1) return true;
    if (!t.kwWords) t.kwWords = t.kw.map(wordsOf).filter(function (w) { return w.length; });
    if (!t.kwWords.length) return false;
    return hasWords(t.kwWords, d);
  }

  /* ------------------------------------------------------------ connectors, sizes, watts */
  /* turns a title / option value into connector markers: C = USB-C, L = Lightning, M = Micro USB, S = MagSafe 3, A = USB-A */
  function mark(s) {
    return ' ' + String(s || '').toLowerCase()
      .replace(/thunderbolt\s*\d*/g, ' C ')
      .replace(/usb[\s-]*c\b|type[\s-]*c\b|typec\b/g, ' C ')
      .replace(/\blightn?ing\b|\blighting\b/g, ' L ')
      .replace(/\bmi(cro|rco)\b/g, ' M ')
      .replace(/\bmag\s*safe\s*3\b|\bmag3\b/g, ' S ')
      .replace(/usb[\s-]*a\b|\busb\b/g, ' A ') + ' ';
  }
  function setOf(m) { var out = []; (m.match(/ [CLMSA] /g) || []).forEach(function (x) { x = x.trim(); if (x !== 'A' && out.indexOf(x) < 0) out.push(x); }); return out; }
  var MULTI = /\b\d\s*-?\s*in\s*-?\s*1\b|\d\s*in\s*1/;
  /* which plug ends at the phone / laptop: "USB-C To Lightning" -> L, "Lightning To USB" -> L, "3-in-1" -> all */
  function endsOf(s) {
    var m = mark(s);
    if (MULTI.test(String(s).toLowerCase())) { var all = setOf(m); return all.length ? all : ['C', 'L', 'M']; }
    var parts = m.split(/\bto\b/);
    if (parts.length > 1) { var after = setOf(parts[parts.length - 1]); return after.length ? after : setOf(parts.slice(0, -1).join(' ')); }
    return setOf(m);
  }
  function meets(list, ports) { return list.some(function (x) { return ports.indexOf(x) > -1; }); }
  /* null = no connector info; true / false = fits or not. noA: USB-A cables don't count (MacBook has no USB-A port) */
  function cableFits(d, ports, noA) {
    var known = false, ok = false;
    function good(s, e) { return meets(e, ports) && !(noA && / A /.test(mark(s))); }
    d.vals.split('|').forEach(function (v) { if (!v) return; var e = endsOf(v); if (e.length) { known = true; if (good(v, e)) ok = true; } });
    if (known) return ok;
    var e = endsOf(d.title);
    return e.length ? good(d.title, e) : null;
  }
  function wattsOf(s) { var w = 0, m, re = /(?:^|[^\d.])(\d{2,4})\s*w\b/gi; while ((m = re.exec(s))) w = Math.max(w, +m[1]); return w; }
  function sizesIn(s) {
    var out = [], m, re = /(\d{1,2}(?:\.\d)?)\s*(?:"|”|″|''|-?\s*inch|in\b)/gi;
    s = String(s || '').replace(/(\d{1,2}(?:\.\d)?)\s*"?\s*\/\s*(\d{1,2}(?:\.\d)?)\s*("|-?\s*inch)/gi, '$1$3 $2$3');
    while ((m = re.exec(s))) {
      var v = parseFloat(m[1]);
      if (v < 9 || v > 18) continue;
      v = v >= 12.8 && v < 13 ? 13 : Math.floor(v);
      if (out.indexOf(v) < 0) out.push(v);
    }
    return out;
  }

  /* ------------------------------------------------------------ device page */
  function sized(src, w) {
    if (!src) return '';
    if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  /* colour names -> swatch colours */
  var SW = { clear: 'transparent', transparent: 'transparent', frost: '#e9eef0', 'rose gold': '#b76e79', titanium: '#8a8a85', 'natural titanium': '#a7a39a', midnight: '#1d2733',
    starlight: '#f3ece1', burgundy: '#800020', nude: '#e3bc9a', mint: '#98e2c6', cream: '#f6f0dc', coffee: '#6f4e37', wine: '#722f37', 'army green': '#4b5320', 'baby pink': '#f4c2c2',
    'baby blue': '#a7c7e7', 'dark gray': '#555', 'dark grey': '#555', 'light gray': '#ccc', 'light grey': '#ccc', 'space gray': '#5b5d60', 'space grey': '#5b5d60', champagne: '#f1ddb5', denim: '#3d5a80' };
  function swatch(name) {
    var n = String(name || '').trim().toLowerCase();
    if (SW[n] != null) return SW[n];
    var c = n.replace(/\s+/g, '');
    try { if (window.CSS && CSS.supports('color', c)) return c; } catch (e) {}
    var last = n.split(/\s+/).pop();
    try { if (window.CSS && CSS.supports('color', last)) return last; } catch (e) {}
    return null;
  }
  var CART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.2 10.5a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H6.2"/><circle cx="9" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/><path d="M12 9.5v4M10 11.5h4"/></svg>';
  function imgTags(src, alt) {
    var srcset = [200, 300, 400, 600, 800, 1000, 1200, 1600].map(function (width) {
      return esc(sized(src, width)) + ' ' + width + 'w';
    }).join(', ');
    return '<img src="' + esc(sized(src, 400)) + '" srcset="' + srcset + '" sizes="(max-width: 749px) calc((100vw - 60px) / 2), (max-width: 989px) calc((100vw - 80px) / 3), calc((100vw - 100px) / 4)" alt="' + esc(alt) + '" loading="lazy" decoding="async">';
  }
  function variantUrl(d, c) { return c && c.vid ? d.url + (d.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + c.vid : d.url; }
  /* pick = index of the colour to show first (the one chosen in the colour filter), -1 = product photo */
  function card(d, cfg, pick) {
    var sale = d.compareCents > d.cents, pct = sale ? Math.round((1 - d.cents / d.compareCents) * 100) : 0;
    var cols = d.colors, sel = pick > -1 ? cols[pick] : null;
    var src = sel && sel.img ? sel.img : d.img, url = variantUrl(d, sel);
    var badge = !d.avail ? '<span class="cd-badge cd-badge--out">' + esc(cfg.t.soldOut) + '</span>' : (pct >= 5 ? '<span class="cd-badge">-' + pct + '%</span>' : '');
    var price = '<div class="price-list">' + (sale
      ? '<span class="price price--highlight"><span class="visually-hidden">' + esc(cfg.t.sale) + '</span>' + esc(d.price) + '</span><span class="price price--compare"><span class="visually-hidden">' + esc(cfg.t.regular) + '</span>' + esc(d.compare) + '</span>'
      : '<span class="price"><span class="visually-hidden">' + esc(cfg.t.sale) + '</span>' + esc(d.price) + '</span>') + '</div>';
    var add = d.avail
      ? (d.vid ? '<button type="button" class="cd-card__add" data-cd-add="' + d.vid + '" aria-label="' + esc(cfg.t.add + ': ' + d.title) + '">' + CART + '</button>'
               : '<a class="cd-card__add" href="' + esc(url) + '" aria-label="' + esc(cfg.t.add + ': ' + d.title) + '">' + CART + '</a>') : '';
    var sw = '';
    if (cols.length > 1) {
      var list = cols.map(function (c, i) { return { c: c, i: i, css: swatch(c.n) }; }).filter(function (x) { return x.css; });
      if (list.length) sw = '<div class="cd-card__sw">' + list.slice(0, 6).map(function (x) {
        return '<button type="button" class="cd-sw' + (x.css === 'transparent' ? ' cd-sw--clear' : '') + (x.i === pick ? ' is-active' : '') + '" style="--sw:' + esc(x.css) + '" data-cd-sw="' + x.i + '" title="' + esc(x.c.n) + '" aria-label="' + esc(x.c.n) + '"></button>';
      }).join('') + (list.length > 6 ? '<a class="cd-sw__more" href="' + esc(d.url) + '">+' + (list.length - 6) + '</a>' : '') + '</div>';
    }
    return '<div class="cd-card' + (d.avail ? '' : ' is-out') + '" data-cd-id="' + d.id + '">' +
      '<div class="cd-card__media"><a class="cd-card__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + badge + (src ? imgTags(src, d.title) : '') + '</a>' + add + '</div>' +
      '<a class="cd-card__title" href="' + esc(url) + '">' + esc(d.title) + '</a>' + sw +
      '<div class="cd-card__price">' + price + '</div></div>';
  }
  function skeleton(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<div class="cd-card cd-card--skeleton"><span class="cd-card__img"></span><span class="cd-line"></span><span class="cd-line cd-line--short"></span></div>';
    return s;
  }

  function initPage(root) {
    if (root.__cd) return; root.__cd = 1;
    var cfgEl = root.querySelector('[data-cd-config]');
    var cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}');
    cfg.t = cfg.t || {};
    var params = new URLSearchParams(location.search);
    var brand = findBrand(params.get('brand') || ''), model = findModel(brand, params.get('model'));
    if (!brand && params.get('model')) { /* brand missing: look it up from the model */
      data().some(function (b) { var m = findModel(b, params.get('model')); if (m) { brand = b; model = m; } return !!m; });
    }
    var finder = root.querySelector('form[data-cd-finder]');
    if (brand && model) { finder.setAttribute('data-current-brand', brand.id); finder.setAttribute('data-current-model', model.label); saveLast(brand, model); }
    initFinder(finder);
    var chg = root.querySelector('[data-cd-change]');
    if (chg) chg.addEventListener('click', function () {
      var open = root.classList.toggle('cd-show-finder'); chg.setAttribute('aria-expanded', open);
      var s = finder.querySelector('select'); if (open && s) s.focus();
    });

    if (!brand || !model) { root.classList.add('cd-page--choose'); return; }
    root.classList.add('cd-page--ready');

    var name = displayName(brand, model);
    root.querySelectorAll('[data-cd-device-name]').forEach(function (el) { el.textContent = name; });
    var sub = root.querySelector('[data-cd-sub]'); if (sub) sub.textContent = (sub.getAttribute('data-text') || '').replace('[device]', name);
    try { document.title = name + ' ' + (cfg.t.titleSuffix || 'accessories') + ' – ' + document.title.split(/[–|-]/).pop().trim(); } catch (e) {}

    var nav = root.querySelector('[data-cd-tabs]'), grid = root.querySelector('[data-cd-grid]'), more = root.querySelector('[data-cd-more]');
    var count = root.querySelector('[data-cd-count]'), seeAll = root.querySelector('[data-cd-seeall]'), seeBottom = root.querySelector('[data-cd-seeall-bottom]');
    var empty = root.querySelector('[data-cd-empty]'), emptyText = empty.querySelector('[data-cd-empty-text]'), emptyLink = empty.querySelector('[data-cd-empty-link]');

    /* categories for this brand: "fit" ones come from scanning every product, the others from their own collection */
    var GROUPS = { phones: ['iphone', 'samsung'], computers: ['ipad', 'macbook'] };
    function forBrand(b) { return !b || b === 'any' || b === brand.id || (GROUPS[b] && GROUPS[b].indexOf(brand.id) > -1); }
    var tabs = (cfg.tabs || []).filter(function (t) { return forBrand(t.brand) &&(t.mode === 'fit' ? (t.handles.length || t.kw.length) : t.handles.length); });
    tabs.forEach(function (t, i) { t.i = i; t.slug = slug(t.title); t.list = []; });
    var usb = isUsbC(brand, model);
    var ports = brand.mac ? ['C', 'S'] : (usb ? ['C'] : ['L']);
    var big = brand.mac ? 0 : Math.max.apply(null, (model.sizes || []).concat([0]));
    var bagSizes = brand.mac ? ({ 13: [13], 14: [13, 14], 15: [15, 16], 16: [15, 16] })[model.mac.size] || [model.mac.size]
      : (big >= 12.8 ? [13, 14] : [10, 11, 12, 13]);    var minW = brand.mac ? (model.mac.line === 'air' ? 30 : (model.mac.size >= 15 ? 85 : 60)) : 0;
    var computer = brand.mac || brand.id === 'ipad';
    var fitted = [], scanDone = false, cur = null, shown = 0, wanted = slug(params.get('tab') || ''), seq = 0;

    function filterOwn(t, rows) {
      var seen = {};
      return rows.map(row).filter(function (d) {
        if (seen[d.id]) return false; seen[d.id] = 1;
        if ((t.kw.length || (t.ex || []).length) && !inTab({ handles: t.kw.length ? [] : ['*'], kw: t.kw, ex: t.ex }, d)) return false;
        var tl = d.title.toLowerCase();
        if (t.mode === 'port') return cableFits(d, ports, brand.mac) === true; /* cables: the plug must fit the device */
        if (t.mode === 'conn') return meets(setOf(mark(d.title + ' ' + d.vals)), ports); /* adapters & hubs: must have the device's port */
        if (t.mode === 'size') { /* bags & sleeves: by screen size */
          if (brand.mac && /\b(ipad|tablet)\b/.test(tl) && !/laptop|macbook/.test(tl)) return false;
          var zs = sizesIn(d.title + ' ' + d.vals.split('|').join(' '));
                    if (!zs.length) return brand.mac ? model.mac.size >= 15 && /backpack/.test(tl) : /backpack|tote|handbag|messenger|shoulder|crossbody|satchel/.test(tl);
          return meets(zs, bagSizes);
        }
        if (t.power) { /* chargers, power banks: right plug on any built-in cable, strong enough for a MacBook */
          var w = wattsOf(d.title);
          if (w > 400) return false;
          if (computer && /magsafe|magnetic|wireless|qi2|watch/.test(tl)) return false;
          if (minW && w < minW) return false;
          if (/cable|connector|built-in/.test(tl)) {
            var part = tl.split(/\bwith\b/).slice(1).join(' ') || tl;
            var e = endsOf(part), fit = cableFits({ vals: d.vals, title: part }, ports);
            if (fit === false || (fit === null && e.length && !meets(e, ports))) return false;
          }
        }
        return true;
      });
    }
    function visible() { return tabs.filter(function (t) { return t.mode === 'fit' ? t.list.length : (!t.loaded || t.list.length); }); }
    function loadTab(t) {
      if (t.loading) return t.loading;
      t.loading = Promise.all(t.handles.map(function (h) { return loadCollection(h, cfg.sort).catch(function () { return []; }); })).then(function (lists) {
        var rows = [].concat.apply([], lists);
        t.list = filterOwn(t, rows); t.loaded = true;
        if (cfg.soldOutLast) t.list.sort(function (a, b) { return (b.avail ? 1 : 0) - (a.avail ? 1 : 0); });
        return t.list;
      });
      return t.loading;
    }
    /* category cards are built once and only shown / hidden, so their pictures load once */
    function renderNav() {
      var vis = visible();
      tabs.forEach(function (t) {
        if (!t.el) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'cd-tab'; b.setAttribute('role', 'tab'); b.setAttribute('data-i', t.i);
          b.innerHTML = '<span class="cd-tab__img">' + (t.img ? '<img src="' + esc(t.img) + '" alt="" width="260" height="260" decoding="async">' : '') + '</span>' +
            '<span class="cd-tab__name">' + esc(t.title) + '</span>';
          nav.appendChild(b); t.el = b;
        }
        t.el.hidden = vis.indexOf(t) < 0;
        t.el.classList.toggle('is-active', t === cur);
        t.el.setAttribute('aria-selected', t === cur);
      });
    }
    /* filters (colours, price) & sort */
    var sortSel = root.querySelector('[data-cd-sort]'), fBtn = root.querySelector('[data-cd-filter-btn]'), fPanel = root.querySelector('[data-cd-filter-panel]'), fN = root.querySelector('[data-cd-filter-n]');
    var fColors = root.querySelector('[data-cd-f-colors]'), fPrice = root.querySelector('[data-cd-f-price]'), fClear = root.querySelector('[data-cd-f-clear]');
    var selColors = [], selPrices = [], buckets = [], filtersFor = null, byId = {};
    var view = [];
    function money(d, units) { return String(d.price).replace(/[\d][\d.,]*/, String(units)); }
    function buildFilters(t) {
      filtersFor = t; selColors = []; selPrices = [];
      /* colours found in this category, most common first */
      var count = {}, names = {};
      t.list.forEach(function (d) {
        var seen = {};
        d.colors.forEach(function (c) { if (seen[c.key] || !swatch(c.n)) return; seen[c.key] = 1; count[c.key] = (count[c.key] || 0) + 1; names[c.key] = names[c.key] || c.n; });
      });
      var keys = Object.keys(count).sort(function (a, b) { return count[b] - count[a]; }).slice(0, 24);
      fColors.innerHTML = keys.map(function (k) {
        var css = swatch(names[k]);
        return '<button type="button" class="cd-fcolor" data-k="' + esc(k) + '" aria-pressed="false"><span class="cd-sw' + (css === 'transparent' ? ' cd-sw--clear' : '') + '" style="--sw:' + esc(css) + '"></span>' + esc(names[k]) + ' <small>' + count[k] + '</small></button>';
      }).join('');
      fColors.parentNode.hidden = !keys.length;
      /* price ranges that actually have products */
      buckets = [];
      var sample = t.list.filter(function (d) { return d.cents && parseFloat(String(d.price).replace(/[^\d.]/g, '')); })[0];
      if (sample) {
        var unit = sample.cents / parseFloat(String(sample.price).replace(/[^\d.]/g, ''));
        var edges = [0, 5, 10, 20, 50, 100, 200, Infinity];
        for (var i = 0; i < edges.length - 1; i++) {
          var lo = edges[i] * unit, hi = edges[i + 1] * unit;
          var n = t.list.filter(function (d) { return d.cents >= lo && d.cents < hi; }).length;
          if (!n) continue;
          var label = i === 0 ? (cfg.t.under || 'Under [price]').replace('[price]', money(sample, edges[1]))
            : edges[i + 1] === Infinity ? (cfg.t.over || '[price] and above').replace('[price]', money(sample, edges[i]))
            : money(sample, edges[i] + ' – ' + edges[i + 1]);
          buckets.push({ lo: lo, hi: hi, label: label, n: n });
        }
      }
      fPrice.innerHTML = buckets.map(function (b, i) { return '<label class="cd-check"><input type="checkbox" data-b="' + i + '"> ' + esc(b.label) + ' <small>' + b.n + '</small></label>'; }).join('');
      fPrice.parentNode.hidden = buckets.length < 2;
      updateFilterUi();
    }
    function updateFilterUi() {
      var n = selColors.length + selPrices.length;
      if (fN) { fN.hidden = !n; fN.textContent = n; }
      if (fClear) fClear.hidden = !n;
      fColors.querySelectorAll('.cd-fcolor').forEach(function (b) { var on = selColors.indexOf(b.getAttribute('data-k')) > -1; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    }
    function colorPick(d) {
      if (!selColors.length) return -1;
      for (var i = 0; i < d.colors.length; i++) if (selColors.indexOf(d.colors[i].key) > -1) return i;
      return -1;
    }
    function makeView(t) {
      if (filtersFor !== t) buildFilters(t);
      var v = t.list.filter(function (d) {
        if (selColors.length && colorPick(d) < 0) return false;
        if (selPrices.length && !selPrices.some(function (i) { var b = buckets[i]; return b && d.cents >= b.lo && d.cents < b.hi; })) return false;
        return true;
      });
      var s = sortSel ? sortSel.value : '';
      if (s) v = v.slice().sort(function (a, b) {
        if (s === 'low') return a.cents - b.cents;
        if (s === 'high') return b.cents - a.cents;
        if (s === 'new') return b.created - a.created;
        return a.title.localeCompare(b.title);
      });
      return v;
    }
    function cards(from, to) { return view.slice(from, to).map(function (d) { byId[d.id] = d; return card(d, cfg, colorPick(d)); }).join(''); }
    function paint(reset) {
      var t = cur; if (!t) return;
      view = makeView(t);
      var list = view;
      if (!reset && shown > list.length) reset = true;
      if (reset) { grid.innerHTML = ''; shown = 0; }
      if (!list.length) {
        if (t.mode === 'fit' ? scanDone : t.loaded) {
          grid.innerHTML = ''; more.hidden = true; count.textContent = (cfg.t.items || 'Items [count]').replace('[count]', 0);
          empty.hidden = false;
          emptyText.textContent = t.list.length ? '' : (cfg.t.none || '').replace('[category]', t.title.toLowerCase()).replace('[device]', name);
          if (emptyLink) emptyLink.href = t.link || ROOT + 'collections/' + (t.handles[0] && t.handles[0] !== '*' ? t.handles[0] : 'all');
        } else if (!grid.children.length) { grid.innerHTML = skeleton(Math.min(cfg.perPage, 10)); }
        return;
      }
      empty.hidden = true;
      if (grid.querySelector('.cd-card--skeleton')) { grid.innerHTML = ''; shown = 0; }
      var target = Math.max(shown, Math.min(cfg.perPage, list.length));
      if (shown < target) { grid.insertAdjacentHTML('beforeend', cards(shown, target)); shown = target; }
      more.hidden = shown >= list.length;
      if (!more.hidden) more.querySelector('[data-cd-more-left]').textContent = String(list.length - shown);
      count.textContent = (cfg.t.items || 'Items [count]').replace('[count]', list.length + (t.mode === 'fit' && !scanDone ? '+' : ''));
    }
    function select(t, user) {
      if (!t) return;
      var changed = cur !== t; cur = t; var my = ++seq;
      renderNav();
      if (user) {
        var b = nav.querySelector('.cd-tab.is-active'); if (b && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        params.set('tab', t.slug);
        try { history.replaceState(null, '', location.pathname + '?' + params.toString()); } catch (e) {}
      }
      var href = t.link || (t.handles[0] && t.handles[0] !== '*' ? ROOT + 'collections/' + t.handles[0] : '');
      [seeAll, seeBottom].forEach(function (a) { if (!a) return; a.hidden = !href; if (href) { a.href = href; a.querySelector('[data-cd-seeall-name]').textContent = t.title.toLowerCase(); } });
      if (changed) { grid.innerHTML = ''; shown = 0; empty.hidden = true; count.textContent = ''; }
      paint(true);
      if (t.mode !== 'fit' && !t.loaded) {
        loadTab(t).then(function () { renderNav(); if (cur === t) paint(true); });
      }
    }
    function pickStart() {
      if (cur && (cur.mode !== 'fit' || cur.list.length)) return;
      var vis = visible(), w = null;
      vis.forEach(function (t) { if (!w && wanted && t.slug === wanted) w = t; });
      if (!w && wanted && !scanDone) return; /* the wanted tab may still appear */
      w = w || vis.filter(function (t) { return t.mode === 'fit'; })[0];
      if (!w && scanDone) w = vis[0];
      if (w) select(w, false);
    }
    nav.addEventListener('click', function (e) { var b = e.target.closest('.cd-tab'); if (b) select(tabs[+b.getAttribute('data-i')], true); });
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var vis = visible(), i = vis.indexOf(cur) + (e.key === 'ArrowRight' ? 1 : -1);
      if (vis[i]) { select(vis[i], true); var b = nav.querySelector('.cd-tab.is-active'); if (b) b.focus(); }
    });
    more.querySelector('button').addEventListener('click', function () {
      var t = cur; if (!t) return;
      grid.insertAdjacentHTML('beforeend', cards(shown, shown + cfg.perPage));
      shown = Math.min(view.length, shown + cfg.perPage);
      more.hidden = shown >= view.length;
      if (!more.hidden) more.querySelector('[data-cd-more-left]').textContent = String(view.length - shown);
    });

    if (fBtn) fBtn.addEventListener('click', function () { fPanel.hidden = !fPanel.hidden; fBtn.setAttribute('aria-expanded', !fPanel.hidden); });
    document.addEventListener('click', function (e) { if (fPanel && !fPanel.hidden && !e.target.closest('.cd-filter')) { fPanel.hidden = true; fBtn.setAttribute('aria-expanded', 'false'); } });
    fColors.addEventListener('click', function (e) {
      var b = e.target.closest('.cd-fcolor'); if (!b) return;
      var k = b.getAttribute('data-k'), i = selColors.indexOf(k);
      if (i > -1) selColors.splice(i, 1); else selColors.push(k);
      updateFilterUi(); paint(true);
    });
    fPrice.addEventListener('change', function () {
      selPrices = [].map.call(fPrice.querySelectorAll('input:checked'), function (c) { return +c.getAttribute('data-b'); });
      updateFilterUi(); paint(true);
    });
    if (fClear) fClear.addEventListener('click', function () {
      selColors = []; selPrices = []; fPrice.querySelectorAll('input').forEach(function (c) { c.checked = false; });
      updateFilterUi(); paint(true);
    });
    /* colour dots on a product: show that colour's photo and link to it */
    grid.addEventListener('click', function (e) {
      var s = e.target.closest('[data-cd-sw]'); if (!s) return;
      var cardEl = s.closest('[data-cd-id]'), d = byId[cardEl.getAttribute('data-cd-id')]; if (!d) return;
      var c = d.colors[+s.getAttribute('data-cd-sw')]; if (!c) return;
      cardEl.querySelectorAll('[data-cd-sw]').forEach(function (x) { x.classList.toggle('is-active', x === s); });
      var url = variantUrl(d, c);
      cardEl.querySelectorAll('a.cd-card__img, a.cd-card__title, a.cd-card__add').forEach(function (a) { a.href = url; });
      if (c.img) {
        var box = cardEl.querySelector('.cd-card__img'), old = box.querySelector('img');
        if (old) old.remove();
        box.insertAdjacentHTML('beforeend', imgTags(c.img, d.title + ' – ' + c.n));
      }
    });
    var sortTxt = root.querySelector('[data-cd-sort-text]');
    if (sortSel) sortSel.addEventListener('change', function () {
      sortSel.parentNode.classList.toggle('is-set', !!sortSel.value);
      if (sortTxt) sortTxt.textContent = sortSel.options[sortSel.selectedIndex].text;
      paint(true);
    });
    /* quick add (single-variant products); the others open the product page */
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cd-add]'); if (!b || b.disabled) return;
      b.disabled = true; b.classList.add('is-busy');
      fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +b.getAttribute('data-cd-add'), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          b.classList.remove('is-busy'); b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); b.disabled = false; }, 1600);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawer = document.getElementById('mini-cart'); if (drawer) drawer.setAttribute('open', '');
        })
        .catch(function () { b.classList.remove('is-busy'); b.disabled = false; window.location.href = ROOT + 'cart'; });
    });

    grid.innerHTML = skeleton(Math.min(cfg.perPage, 10));
    var fitTabs = tabs.filter(function (t) { return t.mode === 'fit'; });
    function onRows(rows) {
      fitted = [];
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (productFits(brand, model, r[8], r[1] + ' ' + (r[12] || ''), r[11])) fitted.push(row(r));
      }
      if (cfg.soldOutLast && scanDone) fitted.sort(function (a, b) { return (b.avail ? 1 : 0) - (a.avail ? 1 : 0); });
      fitTabs.forEach(function (t) { t.list = fitted.filter(function (d) { return inTab(t, d); }); });
      if (cur && cur.mode === 'fit' && !selColors.length && !selPrices.length) filtersFor = null;
      renderNav();
      pickStart();
      if (cur && cur.mode === 'fit') paint(false);
    }
    loadCollection(cfg.scan || 'all', cfg.sort, onRows).then(function (rows) {
      scanDone = true; onRows(rows);
      if (cur && cur.mode === 'fit' && shown <= cfg.perPage) paint(true);
      if (!visible().length) { grid.innerHTML = ''; empty.hidden = false; emptyText.textContent = (cfg.t.none || '').replace('[category]', cfg.t.products || 'products').replace('[device]', name); }
      /* load the other categories now, so their counts show and empty ones disappear */
      tabs.forEach(function (t) { if (t.mode !== 'fit') loadTab(t).then(function () { renderNav(); if (cur === t) paint(true); }); });
    }).catch(function () {
      scanDone = true; grid.innerHTML = ''; empty.hidden = false; emptyText.textContent = cfg.t.error || '';
    });
  }

  function boot() { document.querySelectorAll('[data-cd-page]').forEach(initPage); }
  window.CatchyDevicePage = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();